import Listing from "./scripts/components/Listing";
import { format } from "date-fns";
import { Datepicker, DateRangePicker } from "vanillajs-datepicker";

class WhatsOnListing {
    constructor(element) {
        this.el = element;
        this.form = document.getElementById("whats-on-filters-form");
        this.datesFilter = this.form.querySelector(".dates-filter");
        this.views = document.querySelectorAll('[name="view"]');
        this.datesInput = this.form.querySelector('input[name="dates"]');

        this.init();
    }

    init() {
        this.setupDatePicker();

        if (this.el) {
            this.listing = new Listing({
                root: this.el,
                form: this.form,
                view: "highlights",
                listingId: "whats-on",
                dates: "dates",
                promoInterval: 4,
                pagination: {
                    type: "numbered",
                    perPage: 36,
                },
                html: "/wp-content/uploads/whats-on.html",
                json: "/wp-content/uploads/whats-on.json",
                objectName: {
                    singular: "event",
                    plural: "events",
                },
                callback: () => {
                    // console.log(this.listing.state.filtersStatus);
                },
            });
        }

        this.handleDateInputs();
    }

    setupDatePicker() {
        // Initialize DateRangePicker
        this.datePicker = new DateRangePicker(this.datesFilter, {
            allowOneSidedRange: false,
            autohide: false,
            minDate: new Date(),
            weekStart: 1, // Start week on Monday
            buttonClass: "btn",
            orientation: "left auto",
            maxView: 1, // Limit to Year view
            prevArrow: `<span class="sr-only">Previous Month</span>`,
            nextArrow: `<span class="sr-only">Next Month</span>`,
            // format: "yyyy-mm-dd",
            // container: ".datepicker-dropdown-container",
            format: {
                toValue(date, format, locale) {
                    console.log("toValue date", date);

                    let dateObject;

                    // Check if value matches dd-mm-yy or dd/mm/yy format
                    if (
                        typeof date === "string" &&
                        /^\d{2}[-\/]\d{2}[-\/]\d{2}$/.test(date)
                    ) {
                        const [day, month, year] = date.split("-");
                        // Assume year is 20xx
                        const fullYear = parseInt(year, 10) + 2000;
                        dateObject = new Date(
                            fullYear,
                            parseInt(month, 10) - 1,
                            parseInt(day, 10),
                        );
                    } else {
                        dateObject = Datepicker.parseDate(date, "D d M Y");
                    }

                    return dateObject;
                },
                toDisplay(date, format, locale) {
                    let dateString = Datepicker.formatDate(date, "D d M");

                    if (date.getFullYear() !== new Date().getFullYear()) {
                        dateString += ` ${String(date.getFullYear())}`;
                    }

                    return dateString;
                },
            },
        });
    }

    handleDateInputs() {
        const createCloseBtn = () => {
            if (this.datePicker.datepickers.length) {

                this.datePicker.datepickers.forEach(datepicker => {
                    if(!datepicker.pickerElement.querySelector(".datepicker__close-btn")){
                        const customButton = document.createElement('button');
                        customButton.textContent = 'See results';
                        customButton.classList.add('datepicker__close-btn');

                        customButton.addEventListener('click', () => {
                            datepicker.hide();
                        });

                        const datePickerFooter = datepicker.pickerElement.querySelector('.datepicker-footer');
                        datePickerFooter.insertBefore(customButton, datePickerFooter.firstChild);
                    }
                })
            }
        }

        const removeCloseBtn = () => {
            if (this.datePicker.datepickers.length) {
                this.datePicker.datepickers.forEach(datepicker => {
                    if(datepicker.pickerElement.querySelector(".datepicker__close-btn")){
                        const datePickerFooter = datepicker.pickerElement.querySelector('.datepicker-footer');
                        datePickerFooter.removeChild(datePickerFooter.firstChild);
                    }
                })
            }
        }

        this.datesInput.addEventListener("reset", (e) => {
            this.datePicker.setDates({ clear: true });
        });

        // Slightly hacky workaround - could be solved if this.datePicker was passed to Listing class and handled there
        this.datesInput.addEventListener("loadedFromUrl", (e) => {
            const [start, end] = e.target.value.split(",");

            const startDate = start ? new Date(start) : undefined;
            const endDate = end ? new Date(end) : undefined;

            console.log("dates input loaded", startDate, endDate);

            this.datePicker.setDates(startDate, endDate);
        });

        this.datesFilter.addEventListener("changeDate", (e) => {
            const selectedDates = this.datePicker.getDates();

            console.log("[selectedDates]", selectedDates);

            if (
                this.datesInput &&
                selectedDates.some((date) => date !== undefined)
            ) {
                const [startDate, endDate] = selectedDates;

                if (startDate !== undefined) {
                    this.datesInput.value =
                        format(startDate, "yyyy-MM-dd") +
                        (endDate !== undefined
                            ? `,${format(endDate, "yyyy-MM-dd")}`
                            : "");
                    
                    createCloseBtn();
                } else {
                    removeCloseBtn();
                }
            }


            this.datesInput.dispatchEvent(
                new Event("input", { bubbles: true }),
            );
            this.datesInput.dispatchEvent(
                new Event("change", { bubbles: true }),
            );

            // Update view state if view is in query
            const allShowsView = Array.from(this.views).find(
                (view) => view.value === "all-shows",
            );

            allShowsView.checked = true;
            allShowsView.dispatchEvent(new Event("input", { bubbles: true }));
            allShowsView.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("whats-on-listing");

    if (element) {
        new WhatsOnListing(element);
    }
});
